export default {
  DriverDocumentsPage: {
    title: 'Requested Documents',
    notFound: 'No documents yet',
  },
};
